import { getController, apiService as Service } from '@/services/service'

const url = 'trackleanagreements'

export const trackleanAgreementService = {
	...getController<
		Api.HandoverAgreement,
		Api.HandoverAgreementPostInput,
		Api.HandoverAgreementUpdateInput
	>(url),
	users: () => Service.get({ url: `${url}/users` }),
	whitelabelings: ({ id }: { id: number }) =>
		Service.get({ url: `${url}/users/${id}/whitelabelings` }),
	sendReminder: ({ id, data }: { id: number; data: { email: string } }) =>
		Service.post({ url: `${url}/${id}/send_reminder`, data }),
}

export default trackleanAgreementService
